// ═══════════════════════════════════════════════════════════════════════════════
// Content language resolution (FAQ / legal / PICS body → English for id & fil)
// ═══════════════════════════════════════════════════════════════════════════════
import { LANGUAGE } from '../constants/index.js';
/** FAQ API + DB columns only store zh-Hant / zh-Hans / en. */
export const resolveFaqContentLanguage = (language) => {
    if (language === LANGUAGE.ZH_HANS) {
        return LANGUAGE.ZH_HANS;
    }
    if (language === LANGUAGE.ZH_HANT) {
        return LANGUAGE.ZH_HANT;
    }
    return LANGUAGE.EN;
};
/** Legal documents & PICS body in DB: en / zh-Hant / zh-Hans only. */
export const resolveLegalDocumentLocale = (language) => {
    if (language === LANGUAGE.ZH_HANS) {
        return 'zh-Hans';
    }
    if (language === LANGUAGE.ZH_HANT) {
        return 'zh-Hant';
    }
    return 'en';
};
export const usesEnglishLegalContent = (language) => language === LANGUAGE.ID || language === LANGUAGE.FIL;
/** BCP 47 locale for Intl date/weekday formatting in the main app. */
export const intlLocaleForLanguage = (language) => {
    if (language === LANGUAGE.ZH_HANS) {
        return 'zh-CN';
    }
    if (language === LANGUAGE.ZH_HANT) {
        return 'zh-Hant-TW';
    }
    if (language === LANGUAGE.ID) {
        return 'id-ID';
    }
    if (language === LANGUAGE.FIL) {
        return 'fil-PH';
    }
    return 'en-US';
};
export const usesEnglishWeekdayStyle = (language) => language === LANGUAGE.EN || language === LANGUAGE.ID || language === LANGUAGE.FIL;
/** Task group auto-title builders only support zh-Hant / zh-Hans / en. */
export const resolveTaskGroupTitleLocale = (language) => {
    if (language === LANGUAGE.ZH_HANS) {
        return 'zh-Hans';
    }
    if (language === LANGUAGE.ZH_HANT) {
        return 'zh-Hant';
    }
    return 'en';
};
//# sourceMappingURL=languageContent.js.map